// Extracted verbatim from the v3 monolith (see BIRDSEYE.md module split plan).

export var _matchesField = function (record, field, terms) {
  var values = record.fields[field] || [];
  var lookup = record.fieldLookup ? record.fieldLookup[field] : null;
  if (!terms.length) {
    return true;
  }

  return terms.some(function (term) {
    if (term.mode === 'contains') {
      return values.some(function (value) {
        return value.indexOf(term.value) !== -1;
      });
    }

    if (lookup) {
      return lookup[term.value] === true;
    }

    return values.some(function (value) {
      return value === term.value;
    });
  });
};

export var _searchTextForFields = function (record, fields) {
  var cacheKey = fields.join('|');
  if (Object.prototype.hasOwnProperty.call(record.searchCache, cacheKey)) {
    return record.searchCache[cacheKey];
  }

  var joined = fields
    .map(function (field) {
      return (record.fields[field] || []).join(' ');
    })
    .join(' ');

  record.searchCache[cacheKey] = joined;
  return joined;
};

export var _matchesSearch = function (record, searchGroups) {
  if (!searchGroups.length) {
    return true;
  }

  return searchGroups.every(
    function (group) {
      var haystack = this._searchTextForFields(record, group.fields);
      return group.tokens.every(function (token) {
        return haystack.indexOf(token) !== -1;
      });
    }.bind(this)
  );
};

export var _computeFilteredItems = function (state) {
  var groups = Object.keys(state.filtersByField).map(function (field) {
    return {
      field: field,
      terms: state.filtersByField[field],
    };
  });
  var items = this.items;
  var filtered = [];
  var logicIsOr = state.logic === 'or';
  var hasGroups = groups.length > 0;
  var hasSearch = state.searchGroups.length > 0;
  var i;
  var g;
  var record;
  var filterPass;

  for (i = 0; i < items.length; i += 1) {
    record = items[i];
    filterPass = !hasGroups;

    if (hasGroups) {
      filterPass = logicIsOr ? false : true;

      for (g = 0; g < groups.length; g += 1) {
        var groupMatch = this._matchesField(record, groups[g].field, groups[g].terms);

        if (logicIsOr) {
          if (groupMatch) {
            filterPass = true;
            break;
          }
        } else if (!groupMatch) {
          filterPass = false;
          break;
        }
      }
    }

    if (!filterPass) {
      continue;
    }

    if (hasSearch && !this._matchesSearch(record, state.searchGroups)) {
      continue;
    }

    filtered.push(record);
  }

  return filtered;
};

